import { FunctionComponent, MouseEvent } from 'react'
import Icon from 'components/shared/Icon'

const AdminButton: FunctionComponent<AdminButtonProps> = ({ url, editMode, onClick = () => {} }) => {
  return (
    <a
      href={url}
      title={editMode ? 'Exit edit mode' : 'Enter edit mode'}
      onClick={onClick}
    >
      <Icon name={{ 'icon-pencil': !editMode, 'icon-exit-to-app': editMode }} />
    </a>
  )
}

export interface AdminButtonProps {
  url: string;
  editMode: boolean;
  onClick: (e: MouseEvent<HTMLAnchorElement>) => void
}

export default AdminButton
